import styled from 'styled-components';
import { motion } from 'framer-motion';
import { min, max } from '../../../theme/breakpoints';

export const ContentWrapper = styled(motion.div)`
  margin: 3.125rem auto;

  .section-wrapper {
    @media screen and ${max('largeTablet')} {
      padding: 0;
    }
  }
`;

export const KeyFeaturesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and ${min('largeTablet')} {
    align-items: stretch;
    flex-direction: row;
    margin: 1.875rem 1.75rem 0;
  }
  @media screen and ${min('desktop')} {
    margin: 1.875rem 0 0;
  }
`;

export const Caption = styled.div`
  margin: 1rem 0 0;
  font-size: 0.875rem;
  color: ${({ theme }) => (theme.name === 'uplay' ? theme.colors.SilverChalice : theme.colors.Mako)};
  text-align: center;

  @media screen and ${min('largeTablet')} {
    margin: 3.125rem 0 0;
  }
`;

export const DesktopContainer = styled.div`
  display: none;

  @media screen and ${min('largeTablet')} {
    display: block;
  }
`;

export const MobileTabletContainer = styled.div`
  margin-top: 1rem;
  display: block;

  @media screen and ${min('largeTablet')} {
    display: none;
  }
`;
